<div class="grid">
  <div class="field-radiobutton col" *ngFor="let item of items">
    <p-radioButton name="uploads" [value]="item" [(ngModel)]="selectedItem" [inputId]="item" (onClick)="click()"
                   [disabled]="disabledItems.includes(item)"></p-radioButton>
    <label [for]="item">{{translate(itemPrefix + item + '_label')}}</label>
    <aux-info [content]="translate(itemPrefix + item + '_tooltip')"></aux-info>
  </div>
</div>
